import { useEffect, useRef } from 'react';

/**
 * @description a custom react hook to set page title
 */

const usePageTitle = (title: string, prevailOnMount = false) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnMount) {
        document.title = defaultTitle.current;
      }
    },
    []
  );
};

export default usePageTitle;
